module.exports = __webpack_public_path__ + "img/19.b2b1587e.jpg";